export const CURRENT_LOCATION_PLACE_ID = 'CURRENT_LOCATION';
